import React from 'react';


const IconCheck: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M8.14961 12.1048L15.0894 3.77709L12.9569 2L6.91808 9.24654L3.1288 5.99859L1.32227 8.10621L6.18009 12.2701L7.24864 13.186L8.14961 12.1048Z"
            fill="#4D4E65" />
    </svg>


);

export default IconCheck;